import { popoverAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
  body: {
    bg: "background",
  },
  content: {
    width: "24rem",
    padding: ".5rem",
    borderRadius: "base",
  },
});
export default defineMultiStyleConfig({ baseStyle });
